import { z } from "zod";
import { baglantiSemasi } from "./baglanti";
import { gunSemasi } from "./an-semasi";
import {
  cevapSecenegiSemasi,
  denemeAnSemasi,
  denemeBolumSemasi,
  denemeKimlikSemasi,
  kazanimListesiYuklemeSemasi,
} from "./deneme";

// F-EXM-14/16 — geçici bölüm kimlikleri anahtar ve kazanımı tek atomik kayda bağlar.
export const havuzGirdisiSemasi = denemeKimlikSemasi
  .extend({
    ad: z.string().trim().min(1).max(200),
    denemeTarihi: gunSemasi,
    baslangic: denemeAnSemasi,
    bitis: denemeAnSemasi,
    pdfUrl: baglantiSemasi.nullish(),
    bolumler: z.array(denemeBolumSemasi.extend({ sectionId: z.string().min(1) }).strict()).min(1),
    sorular: z
      .array(
        z
          .object({
            sectionId: z.string().min(1),
            questionNo: z.number().int().min(1).max(500),
            correctAnswer: cevapSecenegiSemasi,
          })
          .strict(),
      )
      .min(1),
    kazanimlar: kazanimListesiYuklemeSemasi.optional(),
  })
  .strict()
  .superRefine((g, ctx) => {
    const hata = (mesaj: string, yol: (string | number)[] = []) =>
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: mesaj, path: yol });
    if (g.bitis <= g.baslangic) hata("Bitiş başlangıçtan sonra olmalı.");
    const bolumler = new Map(g.bolumler.map((b) => [b.sectionId, b]));
    g.bolumler.forEach((b, i) => {
      if (g.bolumler.findIndex((d) => d.sectionId === b.sectionId) !== i)
        hata("Bölüm kimlikleri tekil olmalı.", ["bolumler", i, "sectionId"]);
    });
    const numaralar = new Set<number>();
    for (const [i, s] of g.sorular.entries()) {
      if (!bolumler.has(s.sectionId))
        hata("Anahtarda eşleşmeyen bölüm var.", ["sorular", i, "sectionId"]);
      if (numaralar.has(s.questionNo))
        hata("Soru numarası deneme içinde tekil olmalı.", ["sorular", i, "questionNo"]);
      numaralar.add(s.questionNo);
    }
    for (const [i, b] of g.bolumler.entries()) {
      if (g.sorular.filter((s) => s.sectionId === b.sectionId).length !== b.questionCount)
        hata("Anahtar bölümün soru sayısını tam karşılamalı.", ["bolumler", i, "questionCount"]);
    }
    const toplam = g.bolumler.reduce((t, b) => t + b.questionCount, 0);
    g.sorular.forEach((s, i) => {
      if (s.questionNo > toplam)
        hata("Soru numarası deneme sınırını aşıyor.", ["sorular", i, "questionNo"]);
    });
    for (const [i, s] of (g.kazanimlar?.satirlar ?? []).entries()) {
      if (!g.sorular.some((a) => a.sectionId === s.sectionId && a.questionNo === s.questionNo))
        hata("Kazanımın soru numarası bölümdeki anahtarla eşleşmiyor.", [
          "kazanimlar",
          "satirlar",
          i,
          "questionNo",
        ]);
    }
  });

export type HavuzGirdisi = z.infer<typeof havuzGirdisiSemasi>;
